import angular from 'angular';

import Component from './barGraphPanel.component';
import Service from './barGraphPanel.service';

import './barGraphPanel.component.scss';

export default angular
  .module('petroCloud.dashboard.barGraph', [])
  .component(Component.name, Component)
  .service('BarGraphPanelService', Service)
  .name;
